import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cn from 'classnames';
import { Select as SelectMW, MenuItem, TextField } from 'mw-style-react';
import '../Panel.scss';

/**
 * Компонент Select
 */
class Select extends Component {
  constructor(props) {
    super(props);
    const value = Select.getValue(props.options, props.value);
    this.state = {
      variable: value === 'variable',
    };
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  // Получить значение поля
  static getValue(options, value) {
    const valueItem = Array.isArray(value) ? value[0] : value;
    if (!valueItem) return value;
    const findOpt = options.find(
      (i) => i.value === value.toString() || i.value === valueItem.value
    );
    if (!findOpt) return 'variable';
    return findOpt.value.toString();
  }

  shouldComponentUpdate(nextProps) {
    const { value, options } = this.props;
    return (
      nextProps.value !== value ||
      JSON.stringify(nextProps.options) !== JSON.stringify(options)
    );
  }

  // Выбор статической опции
  handleOnChange({ id, value }) {
    const { onChange } = this.props;
    this.setState({ variable: value === 'variable' });
    onChange({ id, value });
  }

  // Отприсовать опции выбора
  renderItems(options) {
    options = options || [];
    return options.map((i) => (
      <MenuItem key={i.value} value={i.value} label={i.title} />
    ));
  }

  // Отрисовать поле для ввода переменной
  renderVariableField() {
    const { variable } = this.state;
    if (!variable) return null;
    const { id, title, value, errors, handleVarChange } = this.props;
    const error = errors[id];
    const val = value !== 'variable' ? value : '';
    return (
      <TextField
        id={id}
        styleName="panel__el__var"
        bordered={true}
        error={!!error}
        helperText={error || ''}
        value={val}
        placeholder={`Enter "${title}" variable in format {{VAR_NAME}}`}
        onChange={handleVarChange}
        autoFocus={true}
      />
    );
  }

  render() {
    const { id, title, value, options, visibility } = this.props;
    return (
      <div styleName={cn('panel__el')}>
        <SelectMW
          id={id}
          bordered={true}
          label={title}
          value={Select.getValue(options, value)}
          onChange={this.handleOnChange}
          visibility={visibility}
        >
          {this.renderItems(options)}
        </SelectMW>
        <div>{this.renderVariableField()}</div>
      </div>
    );
  }
}

Select.defaultProps = {
  errors: {},
};

Select.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  errors: PropTypes.object,
  options: PropTypes.array,
  onChange: PropTypes.func,
  visibility: PropTypes.string,
  handleVarChange: PropTypes.func,
};

export default Select;
